<!--
  登录弹窗组件 - el-dialog 封装，居中弹出并带从右上角飞入动画
-->
<template>
  <el-dialog
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    title="登录您的账户"
    width="400px"
    :close-on-click-modal="false"
    align-center
    class="login-dialog"
    append-to-body
    @open="panelRef?.resetWechat()"
    @close="panelRef?.cleanupWechat()"
  >
    <LoginPanel
      ref="panelRef"
      @login-success="(data) => { emit('login-success', data); emit('update:modelValue', false) }"
      @register-success="(data) => { emit('register-success', data); emit('update:modelValue', false) }"
      @close="emit('update:modelValue', false)"
    />
  </el-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import LoginPanel from './LoginPanel.vue'

interface Props {
  modelValue: boolean
}

defineProps<Props>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'login-success', data: any): void
  (e: 'register-success', data: any): void
}>()

const panelRef = ref<InstanceType<typeof LoginPanel>>()
</script>

<style>
/* 覆盖 dialog-fade 入场动画，让登录弹窗从右上角飞入居中 */
.dialog-fade-enter-active .login-dialog,
.dialog-fade-enter-active.el-overlay-dialog .login-dialog {
  animation: login-zoom-in 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) both !important;
}

.dialog-fade-leave-active .login-dialog,
.dialog-fade-leave-active.el-overlay-dialog .login-dialog {
  animation: login-zoom-out 0.2s ease-in both !important;
}

@keyframes login-zoom-in {
  from {
    opacity: 0;
    transform: scale(0.6) translate(25%, -25%);
  }
  to {
    opacity: 1;
    transform: scale(1) translate(0, 0);
  }
}

@keyframes login-zoom-out {
  from {
    opacity: 1;
    transform: scale(1) translate(0, 0);
  }
  to {
    opacity: 0;
    transform: scale(0.6) translate(25%, -25%);
  }
}
</style>
